import { supabase } from "../lib/supabaseClient";

const callRPC = async (name, params = {}) => {
  const { data, error } = await supabase.rpc(name, params);
  if (error) throw new Error(error.message);
  return data;
};

export const analyticsAPI = {
  getOverview: async ({ startDate, endDate }) =>
    callRPC("admin_analytics_overview", {
      p_start_date: startDate,
      p_end_date: endDate,
    }),

  getUsers: async ({ search = "", limit = 50, offset = 0, filter = "all" } = {}) =>
    callRPC("admin_user_analytics_list_with_context", {
      p_search: search || null,
      p_limit: limit,
      p_offset: offset,
      p_filter: filter || "all",
    }),

  getUserProfile: async (userId) =>
    callRPC("admin_get_user_analytics", {
      p_user_id: userId,
    }),

  getUserReferrals: async (userId) =>
    callRPC("admin_get_user_referrals", {
      p_user_id: userId,
    }),

  getUserLocations: async (userId) =>
    callRPC("admin_get_user_locations", {
      p_user_id: userId,
    }),

  deleteUser: async (userId) =>
    callRPC("admin_delete_user", {
      target_user_id: userId,
    }),

  deleteLocation: async (locationId) =>
    callRPC("admin_delete_location", {
      p_location_id: locationId,
    }),

  setUserRole: async (userId, role) =>
    callRPC("admin_set_user_role", {
      p_user_id: userId,
      p_role: role,
    }),

  grantPremium: async (userId, days) =>
    callRPC("admin_grant_premium", {
      p_user_id: userId,
      p_days: days,
    }),

  revokePremium: async (userId) =>
    callRPC("admin_revoke_premium", {
      p_user_id: userId,
    }),

  getReferrals: async ({ startDate, endDate, search = "" } = {}) => {
    const [result, payoutTotals] = await Promise.all([
      callRPC("admin_referral_analytics", {
        p_start_date: startDate,
        p_end_date: endDate,
        p_search: search || null,
      }),
      callRPC("admin_referral_payout_totals", {
        p_start_date: startDate,
        p_end_date: endDate,
        p_search: search || null,
      }),
    ]);
    return {
      ...result,
      summary: {
        ...(result?.summary || {}),
        payout_totals: payoutTotals || {},
      },
    };
  },

  setReferralPayout: async ({
    referralId,
    paid,
    amount = null,
    currency = "USD",
    reference = null,
  }) =>
    callRPC("admin_set_referral_payout", {
      p_referral_id: referralId,
      p_paid: paid,
      p_amount: amount,
      p_currency: currency,
      p_reference: reference,
    }),
};
